import * as React from "react";
import { Tooltip } from "@fluentui/react-components";
import { ArrowMove20Regular } from "@fluentui/react-icons";
import { postfachMailNutzlast, ZIEHTYP_POSTFACH_MAIL, type PostfachMailZug } from "./postfachZug";

const TITEL = "Mail in einen Vorgang, ein To-do oder die Dokumente eines Kontakts ziehen";

/**
 * Griff im Kopf des Mailfensters: die ganze Mail ziehen (User 01.11.2026:
 * „Mail in einem Tab in Dokumente in einem anderen Tab ziehen“). Ein eigener
 * Griff statt des Betreffs — den Betreff markieren und kopieren die Nutzer.
 * Die Nutzlast entsteht erst beim Greifen, damit sie den aktuellen Stand der
 * Mail trägt.
 */
export function MailZiehGriff({ zug }: { zug: () => PostfachMailZug }): React.ReactElement {
    return (
        <Tooltip content={TITEL} relationship="label">
            <span
                role="button"
                tabIndex={-1}
                aria-label={TITEL}
                data-testid="mail-zieh-griff"
                draggable
                onDragStart={(e) => {
                    e.dataTransfer.setData(ZIEHTYP_POSTFACH_MAIL, postfachMailNutzlast(zug()));
                    e.dataTransfer.effectAllowed = "copy";
                }}
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 28,
                    height: 24,
                    flexShrink: 0,
                    marginTop: -4,
                    borderRadius: 4,
                    color: "#6b5a66",
                    cursor: "grab",
                }}
            >
                <ArrowMove20Regular />
            </span>
        </Tooltip>
    );
}
